function normalizeSearchPart(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

export function filterEmployeesBySearch(employees, searchQuery) {
  const query = normalizeSearchPart(searchQuery);
  const list = Array.isArray(employees) ? employees : [];
  if (!query) {
    return list;
  }
  return list.filter((employee) => {
    const parts = [
      employee?.last_name,
      employee?.first_name,
      employee?.email,
      employee?.phone,
    ].map(normalizeSearchPart);
    return parts.some((part) => part.includes(query));
  });
}

export const ADMIN_USERS_SHOW_ARCHIVE_KEY = "admin_users_show_archive";

export function filterAdminUsersBySearch(users, searchQuery) {
  const query = normalizeSearchPart(searchQuery);
  const list = Array.isArray(users) ? users : [];
  if (!query) {
    return list;
  }
  return list.filter((user) => {
    const roleName = user?.role_rel?.role_name ?? "";
    const parts = [
      user?.last_name,
      user?.first_name,
      roleName,
    ].map(normalizeSearchPart);
    return parts.some((part) => part.includes(query));
  });
}

/** Search first, then hide inactive when showArchive is false. */
export function filterAdminUsersForPanel(users, searchQuery, showArchive) {
  const searched = filterAdminUsersBySearch(users, searchQuery);
  if (showArchive) {
    return searched;
  }
  return searched.filter((user) => user?.is_active !== false);
}
